var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosGoogleGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2273 35.8228V17.3733L4.83521 12.1387L0 9.2339V32.5669C0 34.3684 1.37549 35.8228 3.06826 35.8228H10.2273Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7727 35.8228H41.9317C43.6296 35.8228 45 34.363 45 32.5669V9.2341L39.5234 12.5612L34.7727 17.3733V35.8228Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2274 17.3733L9.49365 10.1645L10.2274 3.265L22.5001 13.0324L34.7728 3.265L35.5935 9.792L34.7728 17.3733L22.5001 27.1406L10.2274 17.3733Z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7727 3.265V17.3733L45 9.23391V4.89283C45 0.866615 40.6688 -1.42862 37.6365 0.985993L34.7727 3.265Z",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.23394L4.70373 12.9776L10.2273 17.3733V3.26502L7.36348 0.986018C4.32598 -1.42878 0 0.866639 0 4.89267V9.23375V9.23394Z",
    fill: "#C5221F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosGoogleGmail);
export default __webpack_public_path__ + "static/media/logos_google-gmail.9f2f18fdf52e5e1543e214492b4a4253.svg";
export { ForwardRef as ReactComponent };